export default __webpack_public_path__ + "static/media/analytics-logo.a4158cf3.png";